import React, { useContext } from 'react';
import '../Routes/User/Dashboard/dash.css'
// import AuthContext from '../../../context/authcontext';
// import { useNavigate } from 'react-router-dom';
// import link from '../../../backendlink';
import axios from 'axios';
import Navbar from '../Home/Navbar/Navbar';


const AdminDash = (props) => {





  return (
    <div className="user-dashboard">
<Navbar />

      <div className="main-dash">
        <nav className="dashboard-nav tpad30">
          <div className="menu-items">
            <ul className="nav-links">
            <li>
                <a href="#">
                  <i className="uil uil-user"></i>
                  <span className="link-name">ADMIN</span>
                </a>
              </li>
              <li>
                <a href="#dashboard">
                  <i className="uil uil-estate"></i>
                  <span className="link-name">Dashboard</span>
                </a>
              </li>
              
              <li>
                <a href="#">
                  <i className="uil uil-chart"></i>
                  <span className="link-name">Analytics</span>
                </a>
              </li>
              <li>
                <a href="/feedback">
                  <i className="uil uil-feedback"></i>
                  <span className="link-name">Feedback</span>
                </a>
              </li>
              <li>
                <a href="/timetable">
                  <i className="uil uil-schedule"></i>
                  <span className="link-name">Timetable</span>
                </a>
              </li>
             
            </ul>

            <ul className="logout-mode">
              <li>
                <a href="#" >
                  <i className="uil uil-signout"></i>
                  <span className="link-name">Logout</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <section className="dashboard">
          <div className="dash-content">

        




            
            <div className="overview" id='dashboard'>
              <div className="dash-title">
                <i className="uil uil-tachometer-fast-alt"></i>
                <span className="text">Admin Tools</span>
              </div>

              <div className="boxes">
                <a href="/admin/createcc">

                <div className="box box1">
                  <i className="uil uil-ticket"></i>
                  <span className="text">Create Conductor</span>
                  <span className="number"> </span>
                </div>
                </a>
                <a href="/bookings">

                <div className="box box2">
                  <i className="uil uil-subject"></i>
                  <span className="text">View Entries</span>
                  <span className="number"></span>
                </div>
                </a>
                <a href="/">

                <div className="box box3">
                  <i className="uil uil-home"></i>
                  <span className="text">Home</span>
                  <span className="number"></span>
                </div>
                </a>
              </div>
            </div>

             
              
           


          </div>
        </section>
      </div> </div>
  );
};

export default AdminDash;
